export const CLASSES_AND_SPECS = [
  {
    class: "Death Knight",
    color: "#C41E3A",
    icon: "DeathKnight",
    specs: [
      {
        title: "Blood",
      },
      {
        title: "Frost",
      },
      {
        title: "Unholy",
      },
    ],
  },
  {
    class: "Demon Hunter",
    color: "#A330C9",
    icon: "DemonHunter",
    specs: [
      {
        title: "Havoc",
      },
      {
        title: "Vengeance",
      },
    ],
  },
  {
    class: "Druid",
    color: "#FF7C0A",
    icon: "Druid",
    specs: [
      {
        title: "Balance",
      },
      {
        title: "Feral",
      },
      {
        title: "Guardian",
      },
      {
        title: "Restoration",
      },
    ],
  },
  {
    class: "Evoker",
    color: "#33937F",
    icon: "Evoker",
    specs: [
      {
        title: "Augmentation",
      },
      {
        title: "Devastation",
      },
      {
        title: "Preservation",
      },
    ],
  },
  {
    class: "Hunter",
    color: "#AAD372",
    icon: "Hunter",
    specs: [
      {
        title: "Beast Mastery",
      },
      {
        title: "Marksmanship",
      },
      {
        title: "Survival",
      },
    ],
  },
  {
    class: "Mage",
    color: "#3FC7EB",
    icon: "Mage",
    specs: [
      {
        title: "Arcane",
      },
      {
        title: "Fire",
      },
      {
        title: "Frost",
      },
    ],
  },
  {
    class: "Monk",
    color: "#00FF98",
    icon: "Monk",
    specs: [
      {
        title: "Brewmaster",
      },
      {
        title: "Mistweaver",
      },
      {
        title: "Windwalker",
      },
    ],
  },
  {
    class: "Paladin",
    color: "#F48CBA",
    icon: "Paladin",
    specs: [
      {
        title: "Holy",
      },
      {
        title: "Protection",
      },
      {
        title: "Retribution",
      },
    ],
  },
  {
    class: "Priest",
    color: "#FFFFFF",
    icon: "Priest",
    specs: [
      {
        title: "Discipline",
      },
      {
        title: "Holy",
      },
      {
        title: "Shadow",
      },
    ],
  },
  {
    class: "Rogue",
    color: "#FFF468",
    icon: "Rogue",
    specs: [
      {
        title: "Assassination",
      },
      {
        title: "Outlaw",
      },
      {
        title: "Subtlety",
      },
    ],
  },
  {
    class: "Shaman",
    color: "#0070DD",
    icon: "Shaman",
    specs: [
      {
        title: "Elemental",
      },
      {
        title: "Enhancement",
      },
      {
        title: "Restoration",
      },
    ],
  },
  {
    class: "Warlock",
    color: "#8788EE",
    icon: "Warlock",
    specs: [
      {
        title: "Affliction",
      },
      {
        title: "Demonology",
      },
      {
        title: "Destruction",
      },
    ],
  },
  {
    class: "Warrior",
    color: "#C69B6D",
    icon: "Warrior",
    specs: [
      {
        title: "Arms",
      },
      {
        title: "Fury",
      },
      {
        title: "Protection",
      },
    ],
  },
];

export const CLASSES_FOR_URL = [
  "death_knight",
  "demon_hunter",
  "druid",
  "evoker",
  "hunter",
  "mage",
  "monk",
  "paladin",
  "priest",
  "rogue",
  "shaman",
  "warlock",
  "warrior",
];
